'use strict'

const { labeledUrl, accountOriginFromLabeledLocation } = require('./labeled-host')
const { accountOriginFromLocation } = require('./designer-host')

const APP_LABEL = 'app'
const LIVE_APP_DEV_PORT = '10002'
const ACCOUNT_ROUTER_PORT = '8080'
const LIVE_APP_DEV_ORIGIN = 'http://localhost:10002'

function usesLiveDevPort (hostname, port) {

  return String(hostname || '').endsWith('.localhost') && (!port || port === ACCOUNT_ROUTER_PORT)
}

function appPath (application, pathTail) {

  const segments = []
  const applicationName = String(application || '').replace(/^\/+|\/+$/g, '')

  if (applicationName) segments.push(applicationName)

  String(pathTail || '').split('/').forEach((part) => {

    const clean = part.replace(/^\/+|\/+$/g, '')

    if (clean) segments.push(clean)
  })

  if (!segments.length) return '/'

  const path = `/${segments.map((part) => encodeURIComponent(part)).join('/')}`

  return segments.length === 1 ? `${path}/` : path
}

function appUrl (accountOrigin, application, pathTail) {

  const url = new URL(labeledUrl(APP_LABEL, accountOrigin, ''))

  if (usesLiveDevPort(url.hostname, url.port)) {

    url.port = LIVE_APP_DEV_PORT
  }

  url.pathname = appPath(application, pathTail)

  return url.toString()
}

function accountOriginFromAppLocation (location) {

  const origin = accountOriginFromLabeledLocation(APP_LABEL, location)

  if (!origin) return ''

  const url = new URL(origin)

  if (url.hostname.endsWith('.localhost') && url.port === LIVE_APP_DEV_PORT) {

    url.port = ACCOUNT_ROUTER_PORT
  }

  return url.origin
}

function accountNameFromAppLocation (location) {

  const origin = accountOriginFromAppLocation(location)

  if (!origin) return ''

  const name = new URL(origin).hostname.split('.')[0]

  if (!name || name === 'localhost') return ''

  return name
}

function apiFromAppLocation (location, stored) {

  const fromHost = accountOriginFromAppLocation(location)

  if (fromHost) return fromHost

  const params = new URLSearchParams(location && location.search || '')
  const fromQuery = params.get('api')

  if (fromQuery) return fromQuery

  if (stored) return stored

  return 'http://localhost:9998'
}

function liveAppHref (location, api, application, pathTail) {

  const accountOrigin = accountOriginFromLocation(location)

  if (accountOrigin) return appUrl(accountOrigin, application, pathTail)

  return appUrlFallback(application, pathTail, api)
}

function appUrlFallback (application, pathTail, api) {

  const url = new URL(LIVE_APP_DEV_ORIGIN)

  url.pathname = appPath(application, pathTail)

  if (api) url.searchParams.set('api', api)

  return url.toString()
}

function promoteHashRoute (href) {

  const url = new URL(href)

  if (!url.hash.startsWith('#/')) return `${url.pathname}${url.search}`

  const body = url.hash.slice(1)
  const queryAt = body.indexOf('?')
  const path = queryAt === -1 ? body : body.slice(0, queryAt)
  const hashQuery = queryAt === -1 ? '' : body.slice(queryAt + 1)

  if (hashQuery) {

    new URLSearchParams(hashQuery).forEach((value, key) => {

      url.searchParams.set(key, value)
    })
  }

  url.pathname = path.startsWith('/') ? path : `/${path}`
  url.hash = ''

  return `${url.pathname}${url.search}`
}

module.exports = {
  LIVE_APP_DEV_ORIGIN,
  appUrl,
  accountOriginFromAppLocation,
  accountNameFromAppLocation,
  apiFromAppLocation,
  liveAppHref,
  promoteHashRoute
}
